// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"de15e63d","635":"3224dc09","905":"69c3287f"}[chunkId] + ".chunk.js";
};